/*$(".inventory-form").submit(function(e) {

    e.preventDefault();
    var zipval = $('input[name=zip_code]').val();
    var form = $(this);
    var actionUrl = "https://maps-bondfire.uc.r.appspot.com/zipCodeToCoordinates?zip='"+zipval+"'";
    
    $.ajax({
        type: "GET",
        url: actionUrl,
        data: form.serialize(),
        success: function(data)
        {
          latitude = data.location['lat'];
          longitude = data.location['lng'];
          //console.log(latitude);
          //console.log(longitude);

          $.each(data, function(k, v) {
            //console.log(k);
            //console.log(v.lat);
            //console.log(v.lng);
            var storeurl = "https://maps.google.com/?daddr=" + v.lat + "," + v.lng + "&ll=",
            n = document.createElement("div");
            (n.className = "inventory-location"),
            (n.innerHTML ='\n\t\t\t\t\t<h3 class="fw--900 uppercase">\n\t\t\t\t\t\t' +e.name +),
            $('.inventory-form-locations').appendChild(n);
          });
          
          
        }
    });
    
});*/



!(function (t) {
 
    function e(e) {
        for (var n, s, a = e[0], c = e[1], l = e[2], d = 0, m = []; d < a.length; d++) (s = a[d]), Object.prototype.hasOwnProperty.call(r, s) && r[s] && m.push(r[s][0]), (r[s] = 0);
        for (n in c) Object.prototype.hasOwnProperty.call(c, n) && (t[n] = c[n]);
        for (u && u(e); m.length; ) m.shift()();
        return i.push.apply(i, l || []), o();
    }
    function o() {
        for (var t, e = 0; e < i.length; e++) {
            for (var o = i[e], n = !0, a = 1; a < o.length; a++) {
                var c = o[a];
                0 !== r[c] && (n = !1);
            }
            n && (i.splice(e--, 1), (t = s((s.s = o[0]))));
        }
        return t;
    }
    var n = {},
        r = { 20: 0 },
        i = [];
    function s(e) {
        if (n[e]) return n[e].exports;
        var o = (n[e] = { i: e, l: !1, exports: {} });
        return t[e].call(o.exports, o, o.exports, s), (o.l = !0), o.exports;
    }
    (s.m = t),
        (s.c = n),
        (s.d = function (t, e, o) {
            s.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: o });
        }),
        (s.r = function (t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
        }),
        (s.t = function (t, e) {
            if ((1 & e && (t = s(t)), 8 & e)) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var o = Object.create(null);
            if ((s.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t))
                for (var n in t)
                    s.d(
                        o,
                        n,
                        function (e) {
                            return t[e];
                        }.bind(null, n)
                    );
            return o;
        }),
        (s.n = function (t) {
            var e =
                t && t.__esModule
                    ? function () {
                          return t.default;
                      }
                    : function () {
                          return t;
                      };
            return s.d(e, "a", e), e;
        }),
        (s.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (s.p = "");
    var a = (window.shopifySlateJsonp = window.shopifySlateJsonp || []),
        c = a.push.bind(a);
    (a.push = e), (a = a.slice());
    for (var l = 0; l < a.length; l++) e(a[l]);
    var u = c;
    i.push([236, 1, 2]), o();
  console.log(i);
  console.log("********************");
})({
 
  236: function (t, e, o) {
        "use strict";
        o.r(e), o(95);
        var n = o(2),
            r = o(52),
            i = o(53),
            s = o(17),
            a = o(54),
            c = o(55),
            l = o(56),
            u = o(43),
            d = o.n(u),
            m = o(0);
        o(41);
        var p = function t(e, o) {
          console.log(t);
            var n = this;
            !(function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            })(this, t),
                (this.destroy = function () {
                    n.zoomBtn.removeEventListener("click", n.onZoomClick),
                        n.closeBtn.removeEventListener("click", n.resetAllZoom),
                        n.modalUnderlay.removeEventListener("click", n.resetAllZoom),
                        n.extraZoomContainer.removeEventListener("click", n.closeExtraZoom),
                        Object(m.a)(n.cells, function (t) {
                            t.removeEventListener("click", n.onCellClick);
                        }),
                        n.carousel && n.carousel.destroy();
                }),
                (this.resetAllZoom = function () {
                    Object(m.a)(n.zoomedImages, function (t) {
                        t.classList.contains("dn") || t.classList.add("dn");
                    }),
                        n.closeExtraZoom();
                }),
                (this.closeExtraZoom = function () {
                    n.extraZoomContainer.classList.contains("dn") || (n.extraZoomContainer.classList.add("dn"), (n.extraZoom.src = ""));
                }),
                (this.onCellClick = function (t) {
                    var e = t.currentTarget.querySelector("img").src;
                    n.extraZoomContainer.classList.toggle("dn"), (n.extraZoom.src = e);
                }),
                (this.onZoomClick = function (t) {
                    n.carousel.resize(), n.carousel.select(n.originCarousel.selectedIndex, !1, !0);
                }),
                (this.el = e),
                (this.originCarousel = o),
                (this.zoomBtn = document.querySelector(t.zoomBtnSelector)),
                (this.cells = e.querySelectorAll(t.cellSelector)),
                (this.zoomedImages = e.querySelectorAll(t.zoomImageSelector)),
                (this.closeBtn = document.querySelector(t.closeBtnSelector)),
                (this.modalUnderlay = document.querySelector(t.modalUnderlaySelector)),
                (this.extraZoomContainer = document.querySelector(t.extraZoomContainerSelector)),
                (this.extraZoom = document.querySelector(t.extraZoomSelector)),
                this.el.childElementCount > 1 &&
                    (this.carousel = new d.a(this.el, {
                        imagesLoaded: !0,
                        cellAlign: "left",
                        cellSelector: t.cellSelector,
                        contain: !1,
                        wrapAround: !0,
                        prevNextButtons: !0,
                        dragThreshold: 1,
                        pageDots: !1,
                        arrowShape:
                            "M67.1423563,20.7684428 C66.0612938,19.755346 64.3574043,19.7471815 63.2663835,20.7249786 L63.1557561,20.8296464 L33,50.9418397 L63.2200785,79.2325437 C64.3389823,80.2800121 66.123829,80.2517123 67.2066452,79.1693344 C68.2533675,78.1230358 68.2609213,76.4747646 67.2495602,75.4198682 L67.1413028,75.3129066 L40.9755305,50.816818 L67.2056252,24.624903 C68.2529099,23.5791312 68.2613499,21.930864 67.2505561,20.8754588 L67.1423563,20.7684428 Z",
                    })),
                this.zoomBtn.addEventListener("click", this.onZoomClick),
                this.closeBtn.addEventListener("click", this.resetAllZoom),
                this.modalUnderlay.addEventListener("click", this.resetAllZoom),
                this.extraZoomContainer.addEventListener("click", this.closeExtraZoom),
                Object(m.a)(this.cells, function (t) {
                    t.addEventListener("click", n.onCellClick);
                }),
                this.carousel.on("change", this.resetAllZoom);
        };
        (p.domSelector = ".mobile-image-zoom"),
            (p.imageSelector = ".mobile-image-zoom__variant-image"),
            (p.zoomBtnSelector = ".mobile-image-zoom-trigger"),
            (p.cellSelector = ".mobile-image-zoom__slide-visible"),
            (p.zoomImageSelector = ".mobile-image__zoomed"),
            (p.closeBtnSelector = ".mobile-image-zoom__modal .modal__close"),
            (p.modalUnderlaySelector = ".mobile-image-zoom__modal-underlay"),
            (p.extraZoomContainerSelector = ".mobile-image-zoom__extra-zoom-container"),
            (p.extraZoomSelector = ".mobile-image-zoom__extra-zoom"),
            (p.processVariantImages = function (t) {
                var e = document.querySelectorAll(p.imageSelector);
                Object(m.a)(e, function (e) {
                    e.dataset.variants.indexOf(t) > -1 ? (e.classList.add(p.cellSelector.replace(".", "")), e.classList.remove("dn")) : (e.classList.remove(p.cellSelector.replace(".", "")), e.classList.add("dn"));
                });
            });
        var h = p,
            f = o(5),
            v = o.n(f),
            g = o(7),
            S = o.n(g),
            y = o(88),
            b = function t(e, o) {
              
              
                !(function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, t),
                  console.log(this),
                    L.call(this),
                    (this.el = e),
                  console.log(this.el),
                  console.log("==========="),
                    (this.inputEl = e.querySelector(t.inputSelector)),
                    (this.submitButton = e.querySelector(t.submitSelector)),
                    (this.submitButton.disabled = !0),
                    this.el.addEventListener("submit", this.onSubmit),
                    (this.variantId = o),
                    (this.locationsDiv = e.querySelector(t.locationsSelector)),
                    this.displayLoading(),
                    this.processLocations();
                var n = null;
                try {
                    n = localStorage.getItem("zip");
                } catch (t) {
                    console.error(t);
                }
                n ? (this.inputEl.value = n) : this.getCurrentPosition(), this.processLocations();
                if (this.inputEl.value) {
                    this.inputEl.parentNode.classList.add("is-floating");
                }
            };
        (b.domSelector = ".inventory-form"), (b.locationsSelector = ".inventory-form-locations"), (b.inputSelector = "input[name=zip_code]"), (b.submitSelector = "button[type=submit]");
        var L = function () {
          
                var t = this;
                (this.processLocations = function () {
                    t.displayLoading(),
                        y.b(t.variantId).then(function (e) {
                            (t.locations = e.locations.filter(function (t) {
                                return !INVENTORY.hiddenLocationNames.includes(t.name.toLowerCase().trim());
                            })),
                                (t.variantLocationIds = e.variantLocationIds),
                                (t.submitButton.disabled = !1),
                                t.inputEl.value && t.onSubmit();
                        });
                }),
                    (this.displayLocations = function (e) {
                        if (e) {
                            t.displayLoading();
                          console.log(t);
                          console.log("====");
                            var o = t.locations.filter(function (t) {
                              
                                var o = (function (t, e, o, n) {
                                    var r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "M";
                                    if (t == o && e == n) return 0;
                                    var i = (Math.PI * t) / 180,
                                        s = (Math.PI * o) / 180,
                                        a = e - n,
                                        c = (Math.PI * a) / 180,
                                        l = Math.sin(i) * Math.sin(s) + Math.cos(i) * Math.cos(s) * Math.cos(c);
                                    return l > 1 && (l = 1), (l = 60 * (l = (180 * (l = Math.acos(l))) / Math.PI) * 1.1515), "K" == r && (l *= 1.609344), "N" == r && (l *= 0.8684), l;
                                })(e.location.lat, e.location.lng, t.gmaps.location.lat, t.gmaps.location.lng);
                                return (t.distance = Math.round(o)), o <= 100;
                            });
                          console.log(o);
                            o.length > 0
                                ? ((t.locationsDiv.innerHTML = ""),
                                  o
                                      .sort(function (t, e) {
                                          return t.distance - e.distance;
                                      })
                                      .forEach(function (e) {
                                        console.log(e);
                                          var o = "https://maps.google.com/?daddr=" + e.gmaps.location.lat + "," + e.gmaps.location.lng + "&ll=",
                                            
                                            n = document.createElement("div");
                                          (n.className = "inventory-location"),
                                              (n.innerHTML =
                                                  '\n\t\t\t\t\t<h3 class="fw--900 uppercase">\n\t\t\t\t\t\t' +
                                                  e.name +
                                                  "\n\t\t\t\t\t</h3>\n\t\t\t\t\t<address>\n\t\t\t\t\t\t" +
                                                  e.address1 +
                                                  "\n\t\t\t\t\t\t<br>\n\t\t\t\t\t\t" +
                                                  e.city +
                                                  ", " +
                                                  e.province_code +
                                                  " " +
                                                  e.zip +
                                                  "\n\t\t\t\t\t</address>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t" +
                                                  e.distance +
                                                  " " +
                                                  (1 == e.distance ? "mile" : "miles") +
                                                  ' away\n\t\t\t\t\t</p>\n\t\t\t\t\t<a\n\t\t\t\t\t\tclass="link--target-no-hover"\n\t\t\t\t\t\thref="' +
                                                  o +
                                                  '"\n\t\t\t\t\t\ttarget="_blank"\n\t\t\t\t\t>\n\t\t\t\t\t\t<span class="link__target">\n\t\t\t\t\t\t\tDirections\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</a>\n\t\t\t\t'),
                                              t.variantLocationIds.find(function (t) {
                                                  return t == e.id;
                                              })
                                                  ? (n.innerHTML +=
                                                        '\n\t\t\t\t\t\t<p class="fw--900">\n\t\t\t\t\t\t\t<svg width="15px" height="11px" viewBox="0 0 15 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n\t\t\t\t\t\t\t\t<g id="PDP:-In-Store-Locations" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n\t\t\t\t\t\t\t\t\t<g id="Desktop-/-PDP-/-Search-Stores-Pop-up" transform="translate(-598.000000, -491.000000)">\n\t\t\t\t\t\t\t\t\t\t<g id="Modal" transform="translate(307.000000, 118.000000)">\n\t\t\t\t\t\t\t\t\t\t\t<g id="Group-13" transform="translate(243.000000, 266.000000)" fill-rule="nonzero" stroke="#000000" stroke-linecap="square" stroke-width="1.5">\n\t\t\t\t\t\t\t\t\t\t\t\t<polyline id="Path-5" points="49 111.713401 53.5073118 116.220713 61.7280249 108"></polyline>\n\t\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\tAvailable for in-store pickup today\n\t\t\t\t\t\t</p>\n\t\t\t\t\t')
                                                  : (n.innerHTML += '\n\t\t\t\t\t\t<p class="fw--900">\n\t\t\t\t\t\t\tUnavailable at this location\n\t\t\t\t\t\t</p>\n\t\t\t\t\t'),
                                              t.locationsDiv.appendChild(n);
                                      }))
                                : (t.locationsDiv.innerHTML = '\n\t\t\t\t<label class="fw--900 db tc">\n\t\t\t\t\tNo locations found in an 100 miles radius.\n\t\t\t\t</label>\n\t\t\t');
                        } else t.locationsDiv.innerHTML = "<b>Zip code invalid</b>";
                    }),
                    (this.getCurrentPosition = function () {
                        navigator.geolocation &&
                            navigator.geolocation.getCurrentPosition(function (e) {
                                y.a(e.coords.latitude, e.coords.longitude).then(function (e) {
                                    e && (t.inputEl.value = e.zip);
                                });
                            });
                    }),
                    (this.onSubmit = function (e) {
                        e && e.preventDefault();
                      console.log(e);
                        try {
                            localStorage.setItem("zip", t.inputEl.value);
                        } catch (t) {
                            console.error(t);
                        }
                        t.displayLoading(),
                            y.c(t.inputEl.value).then(function (e) {
                                t.displayLocations(e);
                            });
                    }),
                    (this.displayLoading = function () {
                        t.locationsDiv.innerHTML = '<label class="fw--900 pulsing">Fetching Inventory</label>';
                    });
            },
            I = b,
            w = function t(e, o, n, r) {
                var i = this;
                !(function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                })(this, t),
                    C.call(this),
                    (this.el = e),
                    (this.appStore = r),
                    (this.underlay = o),
                    (this.close = e.querySelectorAll(t.closeSelector)),
                    (this.triggers = n),
                    this.underlay.addEventListener("click", this.onClose),
                    Object(m.a)(this.close, function (t) {
                        t.addEventListener("click", i.onClose);
                    }),
                    Object(m.a)(this.triggers, function (t) {
                        t.addEventListener("click", i.onOpen);
                    });
            };
        (w.domSelector = ".inventory-modal__container"), (w.underlaySelector = ".modal__underlay"), (w.closeSelector = ".modal__close"), (w.triggerSelector = ".modal__trigger"), (w.appearTimeout = 5e3), (w.transitionTimeout = 300);
        var C = function () {
                var t = this;
                (this.destroy = function () {
                    Object(m.a)(t.close, function (e) {
                        e.removeEventListener("click", t.onClose);
                    }),
                        t.close.removeEventListener("click", t.onClose),
                        t.underlay.removeEventListener("click", t.onClose);
                }),
                    (this.onOpen = function () {
                        t.el.classList.remove("dn"),
                            t.underlay.classList.remove("dn"),
                            document.documentElement.classList.add("of--hidden"),
                            setTimeout(function () {
                                t.el.classList.add("active"), t.underlay.classList.add("active");
                            }, 50),
                            (t.inventoryForm = new I(t.el.querySelector(I.domSelector), t.appStore.getState().activeProductVariantId));
                    }),
                    (this.onClose = function () {
                        t.el.classList.remove("active"),
                            t.underlay.classList.remove("active"),
                            document.documentElement.classList.remove("of--hidden"),
                            setTimeout(function () {
                                t.el.classList.add("dn"), t.underlay.classList.add("dn");
                            }, w.transitionTimeout);
                    });
            },
            E = w,
            O = document.querySelector(r.a.domSelector),
            A = window,
            j = A.HYDRATE_PRODUCT_ID,
            x = A.HYDRATE_VARIANT_ID,
            V = A.PRODUCT_VARIANT_OPTIONS,
            k = A.PRODUCT_FIT_URL,
            _ = S.a.parse(window.location.search),
            T = Number(_.variant || x);
        n.a.store.setActiveVariantId(T),
            (n.a.inventoryModals = []),
            Object(m.a)(document.querySelectorAll(E.domSelector), function (t) {
                var e = document.querySelector(E.underlaySelector + '[data-modal="' + t.dataset.modal + '"]'),
                    o = document.querySelectorAll(E.triggerSelector + '[data-modal="' + t.dataset.modal + '"]');
                e && o.length > 0 && n.a.inventoryModals.push(new E(t, e, o, n.a.store));
            }),
            (n.a.productFitGuide = new c.a(document.querySelector(c.a.domSelector), k)),
            (n.a.productForm = new i.a(document.querySelector(i.a.domSelector), V, n.a.store)),
            (n.a.backInStockForm = new r.a(O, j, n.a.store)),
            (n.a.zoomImages = Object(m.a)(document.querySelectorAll(l.a.domSelector), function (t) {
                return new l.a(t);
            })),
            v()(V, { id: n.a.store.getState().activeProductVariantId }).isAvailable ? O.classList.add("dn") : O.classList.remove("dn"),
            (n.a.recommendations = new a.a(document.querySelector(a.a.domSelector))),
            s.a.processVariantImages(T),
            (n.a.productHeroCarousel = new s.a(document.querySelector(s.a.domSelector))),
            h.processVariantImages(T),
            (n.a.mobileZoomComponent = new h(document.querySelector(h.domSelector), n.a.productHeroCarousel.carousel)),
            n.a.store.listen(function (t, e) {
                if (t.activeProductVariantId !== e.activeProductVariantId) {
                    n.a.productHeroCarousel.destroy(),
                        n.a.mobileZoomComponent.destroy(),
                        s.a.processVariantImages(t.activeProductVariantId),
                        h.processVariantImages(t.activeProductVariantId),
                        delete n.a.productHeroCarousel,
                        (n.a.productHeroCarousel = new s.a(document.querySelector(s.a.domSelector))),
                        n.a.productHeroCarousel.carousel.resize(),
                        delete n.a.mobileZoomComponent,
                        (n.a.mobileZoomComponent = new h(document.querySelector(h.domSelector), n.a.productHeroCarousel.carousel)),
                        n.a.mobileZoomComponent.carousel.resize(),
                        window.history && window.history.replaceState && window.history.replaceState({}, window.title, window.location.pathname + "?variant=" + t.activeProductVariantId);
                    var o = v()(V, { id: t.activeProductVariantId });
                    n.a.backInStockForm.reset(), o.isAvailable ? O.classList.add("dn") : O.classList.remove("dn");
                }
            });
    },
  
});